/*
 * frete-meta-carrinho.js
 * Barra de progresso do beneficio de frete no CARRINHO e no DRAWER.
 *
 * Sao duas mensagens diferentes, porque sao duas regras diferentes:
 *   CEP 0xxxx (SP capital e Grande SP) -> quanto falta para o FRETE GRATIS.
 *   demais CEPs                        -> quanto falta para a proxima faixa de
 *                                         DESCONTO progressivo, que nao tem teto.
 *
 * Regra pedida pelo Mario: so aparece se o cliente JA informou um CEP em algum
 * momento da sessao. Sem CEP nao da para saber qual das duas mensagens vale, e
 * chutar uma delas daria a promessa errada para metade das pessoas. O CEP fica em
 * sessionStorage: morre quando a aba fecha, entao nao vira dado persistido de quem
 * so passou pela loja.
 *
 * Quem grava o CEP: os dois calculadores de frete, o da PDP v3
 * (product-page-v2.js) e o do carrinho/drawer (shipping-calculator.js).
 */
(function () {
  'use strict';

  var CHAVE_CEP = 'woolie_cep';

  function lerCep() {
    try { return sessionStorage.getItem(CHAVE_CEP) || ''; } catch (e) { return ''; }
  }

  function money(cents) {
    var p = (cents / 100).toFixed(2).split('.');
    return 'R$ ' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }

  function regras() {
    var el = document.getElementById('WoolieFreteRegras');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function montar(el, partes) {
    el.replaceChildren();
    partes.forEach(function (p) {
      if (p.b) {
        var s = document.createElement('strong');
        s.textContent = p.b;
        el.appendChild(s);
      } else {
        el.appendChild(document.createTextNode(p.t));
      }
    });
  }

  // Assinatura do estado ja pintado. Existe para a pintura ser IDEMPOTENTE, e
  // isso nao e detalhe de performance: montar() faz replaceChildren, que e uma
  // mutacao de childList, exatamente o que o MutationObserver la embaixo escuta.
  // Sem esta guarda, pintar disparava o proximo render, que pintava de novo, num
  // laco que media 1 requisicao por segundo a /cart.js com a pagina PARADA.
  // Centavos que estao no carrinho apenas para a cotacao da PDP e vao sair dali a
  // pouco. Ver o uso em calcular().
  var proxyEmVoo = 0;

  // Ultimo estado pintado. Existe para a caixa nao PISCAR: o tema troca o bloco de
  // totais inteiro a cada mexida no carrinho, e a caixa volta escondida. Sem isto,
  // entre a troca e a resposta do /cart.js a barra sumia por 100 a 400ms e o botao
  // FINALIZAR subia uns 70px e descia de novo, a cada clique no mais ou no menos.
  // Pintar do cache primeiro segura o espaco; a rede corrige o numero logo depois.
  var ultimoDados = null;

  function assinatura(dados) {
    return dados.partes.map(function (p) { return p.b || p.t; }).join('') +
           '|' + dados.pct + '|' + dados.batida;
  }

  function pintar(caixa, dados) {
    var sig = assinatura(dados);
    if (caixa.dataset.wlSig === sig) return;
    caixa.dataset.wlSig = sig;

    var txt = caixa.querySelector('.js-frete-meta-txt');
    var barra = caixa.querySelector('.js-frete-meta-barra');
    var preenchida = barra && barra.firstElementChild;

    caixa.hidden = false;
    montar(txt, dados.partes);

    // ATENCAO: o estado "meta batida" vem do dados.batida, calculado sobre o
    // valor em centavos, e NUNCA do percentual. O percentual e arredondado para
    // pintar, e Math.round(599,90 / 600) da 100: um carrinho a dez centavos da
    // meta era tratado como meta batida enquanto o texto ainda dizia "faltam".
    caixa.classList.toggle('is-completa', !!dados.batida);

    if (dados.pct === null) {
      barra.hidden = true;
      return;
    }
    barra.hidden = false;
    // Pelo mesmo motivo o preenchimento para em 99% enquanto falta dinheiro:
    // barra cheia embaixo de "Faltam R$ 0,10" e uma contradicao na tela.
    var v = Math.max(0, Math.min(dados.batida ? 100 : 99, dados.pct));
    if (preenchida) preenchida.style.width = v + '%';
    barra.setAttribute('aria-valuenow', String(v));
  }

  // Devolve null quando nao da para dizer nada de util; render() esconde a caixa.
  function calcular(cart, cep, r) {
    var ehSP = cep.charAt(0) === '0';

    // total_price, e NAO items_subtotal_price. O gateway do FreteFlow decide a
    // gratuidade sobre subtotal_price MENOS discount_amount, ou seja o valor
    // depois do cupom (shipping-rates/index.ts monta o cartTotal assim). E
    // items_subtotal_price da Shopify ignora desconto de PEDIDO: a loja tem
    // dezenas de codigos ativos desse tipo (GOAFFPRO, IG5, MIADORE10...), todos
    // distribuidos por link /discount/CODIGO. Com IG5 num carrinho de R$ 620 fora
    // de SP a barra afirmava "frete gratis liberado" enquanto o gateway avaliava
    // R$ 589 e cobrava frete no checkout. Prometer gratuidade que o checkout
    // desmente e o pior erro que esta barra pode cometer.
    //
    // Bonus de coerencia: total_price e exatamente o numero impresso como "Total
    // estimado" logo acima da barra, na mesma tela.
    var sub = cart.total_price || 0;

    // Desconta o item-proxy que a cotacao da PDP adiciona ao carrinho por alguns
    // segundos. Sem isto, abrir o drawer durante uma cotacao pintava a barra com
    // um carrinho inflado e a promessa ficava gravada: a limpeza que devolve o
    // carrinho ao normal nao avisa ninguem.
    sub = Math.max(0, sub - proxyEmVoo);

    // SP capital e Grande SP: meta unica, frete gratis. Continua como sempre foi.
    if (ehSP) {
      if (!r.sp) return null;
      if (sub >= r.sp) {
        return { partes: [{ b: 'Frete grátis' }, { t: ' liberado para o seu carrinho.' }],
                 pct: 100, batida: true };
      }
      return {
        partes: [{ t: 'Faltam ' }, { b: money(r.sp - sub) }, { t: ' para o frete grátis.' }],
        pct: Math.round((sub / r.sp) * 100),
        batida: false
      };
    }

    // Resto do Brasil: desconto progressivo, sem meta de gratuidade.
    //
    // A barra NAO diz de quanto e o desconto. O valor exato depende da faixa e o
    // preco ja abatido aparece no calculador de frete, que vem do gateway. Dizer um
    // numero aqui seria repetir uma conta que o checkout refaz, que foi exatamente o
    // erro da regra antiga: ela prometia "frete gratis" e o gateway cobrava.
    var d = r.desconto;
    if (!d || !d.inicio || !d.passo) return null;

    if (sub < d.inicio) {
      return {
        partes: [{ t: 'Faltam ' }, { b: money(d.inicio - sub) }, { t: ' para seu frete ter desconto.' }],
        pct: Math.round((sub / d.inicio) * 100),
        batida: false
      };
    }

    // PASSADO O INICIO A BARRA PARA DE CONVIDAR E PASSA A RELATAR.
    //
    // Ate 08/ago/2026 aqui saia "Faltam R$ X para aumentar o desconto do seu frete".
    // Esse texto foi removido porque em produto DENSO E BARATO ele trabalhava contra
    // o cliente. Medido em cotacao real para Curitiba, areia Duna de 4 kg a R$ 69,90:
    //
    //   5 -> 6 sacos: frete +R$ 14,00 para ganhar +R$ 2,50 de desconto
    //   6 -> 7 sacos: frete  +R$ 1,00 para ganhar +R$ 2,50   (aqui compensava)
    //
    // Em 5 dos 7 passos medidos o conselho custava caro ao cliente, e nao da para
    // saber qual passo e qual sem cotar. Tres caminhos foram tentados e descartados:
    //
    //   1. Prever a faixa de peso. A curva de frete e escada, mas os degraus NAO
    //      caem no quilo cheio: 3,000 / 3,200 / 3,600 kg tem tres precos diferentes,
    //      enquanto 4,000 e 4,001 kg tem o mesmo. Prever erra dos dois lados.
    //   2. Estimar por densidade (reais por quilo). Foi implementado e reprovado:
    //      continuava convidando o carrinho de areia, porque compara o custo de
    //      gastar "o que falta" com o ganho de uma faixa inteira, e o cliente nao
    //      gasta "o que falta", ele adiciona um produto inteiro.
    //   3. Medir de verdade, cotando o carrinho hipotetico. Funciona, e o
    //      frete-cotacao.js ate sabe fazer (adiciona o item, cota, desfaz). Mas o
    //      unico jeito e MEXER NO CARRINHO do cliente por alguns segundos. Aceitavel
    //      quando ele clica em "calcular"; inaceitavel de forma automatica, varias
    //      vezes por sessao, em silencio. O proprio frete-cotacao.js documenta o que
    //      ja deu errado nesse intervalo: cliente que adicionava produto durante a
    //      cotacao via o drawer contar o item da cotacao junto.
    //
    // Entao a barra deixa de PREVER e passa a CONSTATAR: mostra os niveis de desconto
    // que o carrinho JA conquistou. Fato consumado nao tem como mentir, nao depende de
    // cotacao, de peso nem de cubagem, e mantem o reforco positivo sem empurrar o
    // cliente numa direcao que as vezes o prejudica.
    //
    // A mensagem de ABAIXO do inicio (logo acima) FICA, e a medicao confirma que ela
    // e honesta: de 4 para 5 sacos, cruzando os R$ 300, o frete CAI R$ 7,00 porque
    // entra a largada de R$ 9,90 do desconto. Convidar para o PRIMEIRO nivel e bom
    // conselho; convidar para os seguintes e que nao era.
    //
    // niveis: R$300 = 1, R$400 = 2, R$500 = 3, e assim por diante, sem teto.
    var niveis = Math.floor((sub - d.inicio) / d.passo) + 1;

    // batida = true pinta a barra no tom de conquista, que aqui e o certo: o cliente
    // ja conseguiu. A barra fica cheia porque nao ha mais meta a perseguir na tela.
    return {
      partes: niveis === 1
        ? [{ t: 'Você conquistou ' }, { b: '1 nível' }, { t: ' de desconto no frete.' }]
        : [{ t: 'Você conquistou ' }, { b: niveis + ' níveis' }, { t: ' de desconto no frete.' }],
      pct: 100,
      batida: true
    };
  }

  // Leitores da mesma versao compartilham a consulta. Quando o drawer troca seus
  // nos durante a leitura, a resposta pinta os nos ATUAIS, sem uma segunda GET.
  // A sequencia impede uma leitura antiga de sobrescrever um carrinho completo
  // que chegou depois pelo evento de quantidade/remocao.
  var emVoo = null, sequencia = 0;

  function carrinhoCompleto(cart) {
    if (window.WoolieCart) return window.WoolieCart.isFullCart(cart);
    return !!(cart && Array.isArray(cart.items) &&
      Number.isFinite(cart.item_count) && Number.isFinite(cart.total_price));
  }

  function pintarCarrinho(cart) {
    if (!carrinhoCompleto(cart)) return;
    var caixas = document.querySelectorAll('.js-frete-meta');
    var cep = lerCep(), r = regras();
    // CEP e proxy podem mudar enquanto a rede responde. Calcular no momento da
    // pintura evita aplicar uma promessa para a localidade anterior.
    var dados = cep && r && cart.item_count ? calcular(cart, cep, r) : null;
    ultimoDados = dados;
    if (!dados) {
      caixas.forEach(function (c) {
        c.hidden = true;
        delete c.dataset.wlSig;
      });
      return;
    }
    caixas.forEach(function (c) { pintar(c, dados); });
  }

  // render(true) pede estado atualizado, usando o payload completo quando veio no
  // evento. Sem forcar, so buscamos o carrinho quando
  // existe caixa AINDA NAO PINTADA. Mutacao de terceiro (widget de chat, carrossel,
  // lazy image) nao tem por que custar uma requisicao.
  //
  // Isso sozinho NAO cobre tudo, e a diferenca entre as duas telas engana: o drawer
  // e reescrito inteiro e a caixa volta sem assinatura, mas na /cart o tema troca
  // apenas o .js-contents de dentro do rodape, e a caixa sobrevive com a assinatura
  // velha. Mudar a quantidade ali deixava a barra congelada. Quem cobre esse caso e
  // a assinatura do evento cartUpdate, la embaixo.
  function render(forcar, cartData) {
    var completo = carrinhoCompleto(cartData);
    if (completo) {
      sequencia++;
      emVoo = null;
      pintarCarrinho(cartData);
      return;
    }

    var caixas = document.querySelectorAll('.js-frete-meta');
    if (!caixas.length) return;

    var cep = lerCep(), r = regras();
    if (!cep || !r) {
      // Sem CEP na sessao a barra simplesmente nao existe para o cliente.
      caixas.forEach(function (c) { c.hidden = true; });
      return;
    }

    var faltaPintar = Array.prototype.some.call(caixas, function (c) { return !c.dataset.wlSig; });
    if (!forcar && !faltaPintar) return;

    // Caixa nova na tela e ja sabemos o que estava escrito: pinta agora, antes da
    // rede, para nao deixar buraco. O valor pode ficar alguns milissegundos velho,
    // o que e muito melhor que a barra sumir e o botao pular.
    if (faltaPintar && ultimoDados) {
      caixas.forEach(function (c) { if (!c.dataset.wlSig) pintar(c, ultimoDados); });
    }

    var compartilhado = window.WoolieCart;
    var revisao = compartilhado ? compartilhado.revision() : 0;
    if (emVoo && emVoo.revisao === revisao) return emVoo.promise;

    var pedido = { revisao: revisao, sequencia: ++sequencia };
    emVoo = pedido;
    var leitura = compartilhado ? compartilhado.getCart() :
      fetch('/cart.js').then(function (res) { return res.json(); });
    pedido.promise = leitura
      .then(function (cart) {
        if (pedido.sequencia !== sequencia) return;
        pintarCarrinho(cart);
      })
      .catch(function () { /* sem carrinho, sem barra: nao vale quebrar a pagina */ })
      .then(function () {
        if (emVoo === pedido) emVoo = null;
      });
    return pedido.promise;
  }

  window.WoolieFreteMeta = {
    render: render,
    // Chamado pela cotacao da PDP: proxy(centavos) ao adicionar o item temporario,
    // proxy(0) depois de remover.
    proxy: function (centavos) {
      proxyEmVoo = Math.max(0, Number(centavos) || 0);
      render(true);
    },
    guardarCep: function (cep) {
      try {
        if (cep && cep.length === 8) {
          sessionStorage.setItem(CHAVE_CEP, cep);
          // Forcado: o CEP novo pode trocar o limiar (Grande SP x resto do Brasil)
          // sem que nenhuma caixa tenha sido substituida no DOM.
          render(true);
        }
      } catch (e) {}
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    render(true);

    // Evento oficial do tema (Dawn) para alteracao de carrinho: publicado por
    // cart.js na troca de quantidade, por product-form.js no add e por
    // quick-add-bulk.js. E o unico sinal que pega a atualizacao IN LOCO da /cart,
    // em que a caixa nao e substituida. A assinatura fica aqui dentro, e nao no
    // corpo do IIFE, porque pubsub.js tambem e defer e pode nao ter rodado ainda.
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          // Alguns fluxos antigos anunciam apenas que houve uma mudanca. Sem o
          // payload, uma leitura iniciada antes desse aviso nao pode ser usada.
          if ((!event || !event.cartData) && window.WoolieCart) window.WoolieCart.invalidate();
          render(true, event && event.cartData);
        });
      }
    } catch (e) {}
  });

  // O drawer troca o HTML dele inteiro a cada alteracao do carrinho, e o script
  // inline que viesse junto nao executaria. Por isso observamos o DOM: quando a
  // caixa reaparece (ou o carrinho muda), redesenhamos.
  // ATENCAO: nao usar debounce aqui. Debounce reinicia o timer a cada mutacao, e
  // a abertura do drawer gera mutacoes em rajada continua: o timer nunca chegava
  // a disparar e a barra ficava vazia dentro do drawer. Este agendamento NAO
  // reinicia: a primeira mutacao da rajada marca o render e ele acontece, as
  // seguintes sao ignoradas ate ele rodar.
  var agendado = null;
  new MutationObserver(function () {
    if (agendado) return;
    agendado = setTimeout(function () { agendado = null; render(false); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
